module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "controls"
    }
  }, [_c('div', [_c('h1', [_vm._v("Heroes of the Storm Bingo Generator")]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("Number of boards")]), _vm._v(" "), _c('dd', {
    staticClass: "boards-count"
  }, [_c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 10,
      "tooltip": "hover"
    },
    model: {
      value: (_vm.count),
      callback: function($$v) {
        _vm.count = $$v
      },
      expression: "count"
    }
  })], 1), _vm._v(" "), _c('dt', [_vm._v("Phrase set")]), _vm._v(" "), _c('dd', {
    staticClass: "phrase-set"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.phrases.sets.available,
      "show-labels": false,
      "allow-empty": false,
      "label": "text",
      "track-by": "key"
    },
    on: {
      "input": _vm.updatePhrases
    },
    model: {
      value: (_vm.phrases.sets.selected),
      callback: function($$v) {
        _vm.phrases.sets.selected = $$v
      },
      expression: "phrases.sets.selected"
    }
  })], 1)]), _vm._v(" "), _c('h3', [_vm._v("How to use")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.shuffle
    }
  }, [_c('span', [_vm._v("Shuffle")])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v("Print")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Choose your desired phrase set.")]), _vm._v(" "), _c('li', [_vm._v("Adjust number of boards to match players.")]), _vm._v(" "), _c('li', [_vm._v("Print this page. It will automatically be converted to the printer friendly version.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3172b74d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Controls.vue
// module id = 16
// module chunks = 0